import { DataSourceConfig, PATIENT_ID } from '@stores';
import { isAndroid, isIos } from '@utils';

import { GlobalAPIService } from '../global-api-service';
import { DataGatewayService } from './data-gateway';

export const initializeGateway = async (
  params: DataSourceConfig | Partial<DataSourceConfig>
) => {
  const config = { ...params };

  if (!params.apiKey && params.projectId && params.patientSourceUUID) {
    const response = await GlobalAPIService.getFirebaseData(
      params.projectId,
      params.patientSourceUUID
    );
    if (!response) throw new Error('Firebase data should not be null!');
    config.patientSourceUUID = params.patientSourceUUID;
    config.apiKey = response.apiKey;
    config.authDomain = response.authDomain;
    config.databaseURL = response.databaseURL;
    config.storageBucket = response.storageBucket;
    if (isIos()) {
      config.appId = response.iOSAppId;
    } else if (isAndroid()) {
      config.appId = response.androidAppId;
    }
    config.projectId = params.projectId;
    config.patientId = PATIENT_ID;
    config.isPrimary = !!params.isPrimary;
  }

  const gateway = new DataGatewayService(config as DataSourceConfig);
  return {
    config: config as DataSourceConfig,
    gateway,
  };
};
